import { getRequestOrigin } from '../helper';
import { IwanRequestConfig } from '../interface';

export const iwanBaseUrl = (config: IwanRequestConfig): IwanRequestConfig => {
  const retConfig = config;
  if (config.baseURL) {
    return retConfig;
  }

  retConfig.baseURL = `${getRequestOrigin({
    env: config.env,
    iwanType: config.iwanType,
    defaultBiz: config.defaultBiz,
  })}`;
  return retConfig;
};
